var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 9.08534L1.45738 10.014C0.694472 10.8753 0.887492 12.2155 1.86244 12.8264V12.8264C2.49492 13.2228 2.82774 13.9702 2.71088 14.7074V14.7074C2.53196 15.8361 3.41145 16.8738 4.55412 16.8553V16.8553C5.29816 16.8433 5.97892 17.2871 6.27462 17.97V17.97C6.72922 19.0197 8.02986 19.4109 8.97921 18.7726V18.7726C9.59647 18.3576 10.4035 18.3576 11.0208 18.7726V18.7726C11.9701 19.4109 13.2708 19.0197 13.7254 17.97V17.97C14.0211 17.2871 14.7018 16.8433 15.4459 16.8553V16.8553C16.5885 16.8738 17.468 15.8361 17.2891 14.7074V14.7074C17.1723 13.9702 17.5051 13.2228 18.1376 12.8264V12.8264C19.1125 12.2155 19.3018 10.8711 18.5389 10.0098V10.0098C18.0433 9.45035 17.9303 8.63922 18.2489 7.96313V7.96313C18.7375 6.92651 18.1828 5.68554 17.079 5.3774V5.3774C16.3613 5.17703 15.8323 4.55471 15.739 3.8154V3.8154C15.596 2.68232 14.4597 1.93527 13.3702 2.2777V2.2777C12.6608 2.50065 11.8866 2.27212 11.4116 1.70001V1.70001C10.6783 0.816849 9.32239 0.816066 8.58907 1.69922L7.80266 2.64631",
    stroke: "#4F4F4F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75301 1.69186C2.46012 1.39897 1.98525 1.39897 1.69235 1.69186C1.39946 1.98476 1.39946 2.45963 1.69235 2.75252L2.75301 1.69186ZM1.69235 2.75252L10.2396 11.2998L11.3002 10.2391L2.75301 1.69186L1.69235 2.75252Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69824 10.7809H10.6982V6.33643",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.9e446137.svg";
export { ForwardRef as ReactComponent };